import { EMOTIONS } from '@/constants';
import { EmojiRate, ProjectPeerEvaluationRequestDTO, MemberPeerEvaluationDTO, UserDTO } from '@/models';

export const buildPeerEvaluation = (
  user: UserDTO,
  recipient: UserDTO,
  projectAssessmentId: number
): MemberPeerEvaluationDTO => {
  return {
    user,
    recipient,
    projectAssessmentId,
    accountabilityPoint: 0,
    professionalConductPoint: 0,
    communicationPoint: 0,
    personalAttributesPoint: 0,
    supportivenessPoint: 0,
    givingDrops: 0,
    keepDoing: '',
    stopDoing: ''
  };
};

export const buildPeerEvaluationAction = (
  projectPeerEvaluation: MemberPeerEvaluationDTO
): ProjectPeerEvaluationRequestDTO => {
  return {
    userId: projectPeerEvaluation.user.id,
    recipientId: projectPeerEvaluation.recipient.id,
    projectAssessmentId: projectPeerEvaluation.projectAssessmentId,
    accountabilityPoint: projectPeerEvaluation.accountabilityPoint,
    professionalConductPoint: projectPeerEvaluation.professionalConductPoint,
    communicationPoint: projectPeerEvaluation.communicationPoint,
    personalAttributesPoint: projectPeerEvaluation.personalAttributesPoint,
    supportivenessPoint: projectPeerEvaluation.supportivenessPoint,
    givingDrops: projectPeerEvaluation.givingDrops,
    keepDoing: projectPeerEvaluation.keepDoing,
    stopDoing: projectPeerEvaluation.stopDoing
  };
};

export const buildListEmoji = (isActive: boolean): EmojiRate[] => {
  return [
    { point: 1, icon: EMOTIONS.WORST, isActive },
    { point: 2, icon: EMOTIONS.POOR, isActive },
    { point: 3, icon: EMOTIONS.SO_SO, isActive },
    { point: 4, icon: EMOTIONS.OKAY, isActive },
    { point: 5, icon: EMOTIONS.SUPERB, isActive }
  ];
};
